import React, { useState } from 'react';
import { Flex, Text, Toggle, Pane, Toast, Label } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import S from './BleObdsCard.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BleObdsCard = props => {
  const {
    sharedProps: {
      item,
      actions
    }
  } = props;
  const [enabled, setEnabled] = useState(!!item?.metadata?.bleObdEnabled);
  const [loading, setLoading] = useState(false);
  const onToggle = async () => {
    setLoading(true);
    try {
      await GlobalState.dispatch(actions.update({
        metadata: {
          bleObdEnabled: !enabled
        }
      }));
      setEnabled(prevEnabled => !prevEnabled);
    } catch (err) {
      Toast.error('Error updating BLE OBD enabled');
    }
    setLoading(false);
  };
  return /*#__PURE__*/_jsx(Pane, {
    variant: "dataCard",
    className: S.pane,
    children: /*#__PURE__*/_jsxs(Flex, {
      variant: "colL",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "detailLabel",
        children: "Enable or disable BLE OBDs in this location"
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "rowL",
        children: [/*#__PURE__*/_jsx(Toggle, {
          variant: "default",
          value: enabled,
          disabled: loading,
          eventData: "enabled",
          onChange: onToggle
        }), /*#__PURE__*/_jsx(Label, {
          variant: "inputCaption",
          className: S.label,
          children: enabled ? 'Disable BLE OBDs' : 'Enable BLE OBDs'
        })]
      })]
    })
  });
};
export default BleObdsCard;